import { QueryClient } from '@tanstack/react-query';
import { QUERY_CONFIG } from '@/shared/config/constants';

function isRetryableError(error: unknown): boolean {
  if (error instanceof Error && 'status' in error) {
    const status = (error as Error & { status: number }).status;
    return [429, 500, 502, 503, 504].includes(status);
  }
  if (error instanceof TypeError && error.message === 'Failed to fetch') {
    return true;
  }
  return false;
}

/**
 * Module-level singleton so authStore.signOut() can call queryClient.clear()
 * without needing a React context reference.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_CONFIG.STALE_TIME,
      gcTime: QUERY_CONFIG.GC_TIME,
      retry: (failureCount, error) => {
        if (failureCount >= QUERY_CONFIG.RETRY_MAX) return false;
        return isRetryableError(error);
      },
      retryDelay: (attemptIndex) =>
        Math.min(
          QUERY_CONFIG.RETRY_DELAY_BASE * 2 ** attemptIndex,
          QUERY_CONFIG.RETRY_DELAY_MAX,
        ),
    },
    mutations: {
      retry: false,
    },
  },
});
